module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-item"
  }, [(_vm.collection === 'wwf-au-web') ? _c('search-item-web', {
    attrs: {
      "item": _vm.item
    }
  }) : (_vm.collection === 'wwf-au-faq') ? _c('search-item-faq', {
    attrs: {
      "item": _vm.item
    }
  }) : (_vm.collection === 'wwf-au-youtube') ? _c('search-item-youtube', {
    attrs: {
      "item": _vm.item
    }
  }) : (_vm.collection === 'wwf-au-instagram') ? _c('search-item-instagram', {
    attrs: {
      "item": _vm.item
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ba03d4c6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=mivovjqocqq!./~/string-replace-webpack-plugin/loader.js?id=q7vc8icot8a!./src/components/search/searchItem.vue
// module id = 448
// module chunks = 1